interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  return (
    <nav className="flex items-center justify-center gap-2 mt-8 md:mt-10" aria-label="分页导航">
      <button
        type="button"
        disabled={page <= 1}
        onClick={() => onChange(page - 1)}
        className="w-10 h-10 rounded-md bg-background-800 flex items-center justify-center text-foreground-300 cursor-pointer transition-colors hover:bg-background-700 hover:text-foreground-50 disabled:opacity-40 disabled:cursor-not-allowed"
        aria-label="上一页"
      >
        <i className="ri-arrow-left-s-line text-lg"></i>
      </button>

      {pages.map((p) => (
        <button
          key={p}
          type="button"
          onClick={() => onChange(p)}
          className={`w-10 h-10 rounded-md text-sm font-medium cursor-pointer transition-colors ${
            p === page
              ? "bg-primary-500 text-background-50"
              : "bg-background-800 text-foreground-300 hover:bg-background-700 hover:text-foreground-50"
          }`}
          aria-current={p === page ? "page" : undefined}
        >
          {p}
        </button>
      ))}

      <button
        type="button"
        disabled={page >= totalPages}
        onClick={() => onChange(page + 1)}
        className="w-10 h-10 rounded-md bg-background-800 flex items-center justify-center text-foreground-300 cursor-pointer transition-colors hover:bg-background-700 hover:text-foreground-50 disabled:opacity-40 disabled:cursor-not-allowed"
        aria-label="下一页"
      >
        <i className="ri-arrow-right-s-line text-lg"></i>
      </button>
    </nav>
  );
}